import React from "react";
import Breadcrumb from "antd/es/breadcrumb";
import { Typography } from "antd";
import Card from "antd/es/card/Card";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";

import clsx from "clsx";
import styles from "./index.module.scss";

interface SinglePageContainer extends React.PropsWithChildren {
  breadcrumbItems?: ItemType[];
  title: React.ReactNode;
  extra?: React.ReactNode;
  cardLoading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  stickyHeader?: boolean;
}

export default function SinglePageContainer({
  breadcrumbItems = [],
  title,
  cardLoading = false,
  extra = undefined,
  children,
  className = "",
  style,
  stickyHeader = false,
}: SinglePageContainer) {
  return (
    <div className="transparent">
      {breadcrumbItems.length > 0 ? (
        <Breadcrumb
          className="page-header-breadcrumb"
          items={breadcrumbItems}
        />
      ) : null}

      <div
        className={clsx(styles.heading, {
          [styles.stickyHeader]: stickyHeader,
        })}
      >
        <Typography.Title level={4} className={styles.pageTitle}>
          {title}
        </Typography.Title>
        <div className={clsx("flex-row-wrapper", styles.extra)}>{extra}</div>
      </div>

      {/* styles={{ body: { padding: '16px' } }} */}
      <Card loading={cardLoading} className={className} style={style}>
        {children}
      </Card>
    </div>
  );
}
